export default function Hero({ heroState = 'loading', logo }) {
  const showFallback = heroState === 'failed';

  return (
    <section id="hero" className="spss-hero relative">
      {showFallback && logo && (
        <div
          className="spss-hero-fallback spss-fallback-enter"
          style={{ zIndex: 5, pointerEvents: 'auto' }}
        >
          <div className="spss-fallback-canvas">
            <div className="spss-retro-computer">
              <div className="spss-retro-monitor">
                <div className="spss-retro-screen spss-scanlines">
                  <img src={logo} alt="SPSS" className="spss-retro-logo" />
                  <span className="spss-retro-cursor" />
                </div>
                <div className="spss-retro-brand">SPSS</div>
              </div>
              <div className="spss-retro-stand" />
              <div className="spss-retro-base" />
            </div>
          </div>
        </div>
      )}

      <div
        className="absolute bottom-6 left-0 right-0 flex flex-col items-center gap-1 pointer-events-none"
        style={{ zIndex: 10, animation: 'spss-scroll-indicator 2s ease-in-out infinite' }}
      >
        <span
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'rgba(220,235,255,0.7)',
            letterSpacing: '0.12em',
            textShadow: '0 0 10px rgba(200,220,255,0.3)',
          }}
        >
          SCROLL DOWN
        </span>
        <span style={{ color: 'rgba(220,235,255,0.6)', fontSize: '0.8rem', textShadow: '0 0 8px rgba(200,220,255,0.25)' }}>▼</span>
      </div>
    </section>
  );
}
